export type RingOutcome = 'answered' | 'declined' | 'missed';

const MAX_REMEMBERED = 500;

export class RingOutcomeStore {
    private readonly outcomes = new Map<string, RingOutcome>();
    private readonly listeners = new Set<() => void>();

    peek(eventId: string): RingOutcome | undefined {
        return this.outcomes.get(eventId);
    }

    record(eventId: string, outcome: RingOutcome): void {
        if (this.outcomes.get(eventId) === outcome) {
            return;
        }
        this.outcomes.delete(eventId);
        this.outcomes.set(eventId, outcome);
        if (this.outcomes.size > MAX_REMEMBERED) {
            const oldest = this.outcomes.keys().next().value;
            if (oldest !== undefined) {
                this.outcomes.delete(oldest);
            }
        }
        this.listeners.forEach(listener => listener());
    }

    subscribe = (listener: () => void): (() => void) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };

    clear(): void {
        this.outcomes.clear();
        this.listeners.forEach(listener => listener());
    }
}

export const ringOutcomes = new RingOutcomeStore();
